import React from 'react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { Button } from '@duck/ui'
import { useTar } from '@/modules'

interface NoDataEmptyStateProps {
  title?: string
  description?: string
  buttonText?: string
  onButtonClick?: () => void
  icon?: React.ComponentType<{ className?: string }>
}

export const NoDataEmptyState: React.FC<NoDataEmptyStateProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
  icon: Icon = ExclamationTriangleIcon
}) => {
  const { t } = useTar()

  return (
    <div className="text-center py-12">
      <Icon className="w-16 h-16 text-muted mx-auto mb-4" />
      <h3 className="text-xl font-semibold text-foreground mb-2">
        {title || t('challenges.noAvailableYet')}
      </h3>
      <p className="text-muted-foreground mb-6 px-4">
        {description || t('challenges.noAvailableDescription')}
      </p>
      {buttonText && onButtonClick && (
        <Button onClick={onButtonClick}>
          {buttonText}
        </Button>
      )}
    </div>
  )
}
